// this is used when rendering an in-person-only route, before the "onlineOnly" preference has been fetched
const EMPTY_STEP = {
  index: null,
  header: '',
  label: '',
  path: ''
}

const NEW_ACCOUNT_STEP = {
  header: 'New Account',
  label: 'New Account',
  path: '/',
  continueHelpText: 'Please create an account to continue.',
  isCompleted: account => true
}

const PARENTS_STEP = {
  header: 'Parents / Guardians',
  label: 'Parents',
  path: '/parents',
  continueHelpText: 'Please add or edit Parents/Guardians to continue.',
  isCompleted: account => account && account.registrationStatus.validParents
}

const CAMPERS_STEP = {
  header: 'Campers',
  label: 'Campers',
  path: '/campers',
  continueHelpText: 'Please add or edit Campers to continue.',
  isCompleted: account => account && account.registrationStatus.validCampers
}

const EMERGENCY_CONTACTS_STEP = {
  header: 'Emergency Contacts',
  label: 'Contacts',
  path: '/emergency_contacts',
  continueHelpText: 'Please add or edit Emergency Contacts to continue.',
  isCompleted: account =>
    account && account.registrationStatus.validEmergencyContacts
}

const PICK_UP_PEOPLE_STEP = {
  header: 'Pick-Up People',
  label: 'Pick-Up People',
  path: '/pickup_people',
  continueHelpText: 'Please add or edit Pick-Up People to continue.',
  isCompleted: account =>
    account && account.registrationStatus.validEmergencyContacts
}

const PLANS_STEP = {
  header: 'Select Plans',
  label: 'Select Plans',
  path: '/cart',
  continueHelpText: null,
  isCompleted: account => account && account.registrationStatus.validCart
}

const PAYMENT_STEP = {
  header: 'Add a Payment',
  label: 'Payment',
  path: '/payment',
  continueHelpText: null,
  isCompleted: account =>
    account && account.registrationStatus.validPaymentMethod
}

const CONFIRM_STEP = {
  index: 7,
  header: 'Confirm Registration',
  label: 'Confirm',
  path: '/confirm',
  continueHelpText: null,
  isCompleted: account => account && account.registrationStatus.registered
}

const COMPLETE_STEP = {
  index: 8,
  header: 'Registration Complete',
  label: 'Done',
  path: '/complete',
  continueHelpText: null,
  isCompleted: account => account && account.registrationStatus.registered
}

const IN_PERSON_STEPS = [
  Object.assign({ index: 0 }, NEW_ACCOUNT_STEP),
  Object.assign({ index: 1 }, PARENTS_STEP),
  Object.assign({ index: 2 }, CAMPERS_STEP),
  Object.assign({ index: 3 }, EMERGENCY_CONTACTS_STEP),
  Object.assign({ index: 4 }, PICK_UP_PEOPLE_STEP),
  Object.assign({ index: 5 }, PLANS_STEP),
  Object.assign({ index: 6 }, PAYMENT_STEP),
  Object.assign({ index: 7 }, CONFIRM_STEP),
  Object.assign({ index: 8 }, COMPLETE_STEP)
]

const ONLINE_STEPS = [
  Object.assign({ index: 0 }, NEW_ACCOUNT_STEP),
  Object.assign({ index: 1 }, PARENTS_STEP),
  Object.assign({ index: 2 }, CAMPERS_STEP),
  Object.assign({ index: 3 }, PLANS_STEP),
  Object.assign({ index: 4 }, PAYMENT_STEP),
  Object.assign({ index: 5 }, CONFIRM_STEP),
  Object.assign({ index: 6 }, COMPLETE_STEP)
]

const REG_FLOWS = {
  inPerson: IN_PERSON_STEPS,
  onlineOnly: ONLINE_STEPS
}

// return the current step, and add array index for stepper
const getCurrentStep = ({ pathname, onlineOnly }) =>
  getSteps({ onlineOnly }).find(step =>
    step.path === '/'
      ? step.path === pathname
      : pathname.indexOf(step.path) === 0
  ) || EMPTY_STEP

const getSteps = ({ onlineOnly }) =>
  onlineOnly || onlineOnly === undefined
    ? REG_FLOWS.onlineOnly
    : REG_FLOWS.inPerson

const getPreviousStep = ({ step, onlineOnly }) =>
  getSteps({ onlineOnly })[step.index - 1]

const getNextStep = ({ step, onlineOnly }) =>
  getSteps({ onlineOnly })[step.index + 1]

const canContinue = ({ step, account }) => step.isCompleted(account)

export {
  getSteps,
  canContinue,
  getCurrentStep,
  getPreviousStep,
  getNextStep,
  PAYMENT_STEP
}
